import { cn } from '../../../../lib/utils';
import { cva } from 'class-variance-authority';

export interface LoadingIndicatorProps {
  /** 로딩 인디케이터 크기 */
  size: 'lg' | 'md' | 'sm';
  /** 로딩 인디케이터 타입 */
  type: 'circular' | 'linear';
  /** 로딩 인디케이터 클래스네임 */
  className?: string;
}

const loadingIndicatorVariants = cva([''], {
  variants: {
    size: {
      lg: '',
      md: '',
      sm: '',
    },
    type: {
      circular: '',
      linear:
        'relative w-full rounded-full overflow-hidden bg-comp-loading-indicator-track-bg',
    },
  },
  compoundVariants: [
    {
      size: 'lg',
      type: 'circular',
      className: 'size-[24px] shrink-0',
    },
    {
      size: 'md',
      type: 'circular',
      className: 'size-[20px] shrink-0',
    },
    {
      size: 'sm',
      type: 'circular',
      className: 'size-[16px] shrink-0',
    },
    {
      size: 'lg',
      type: 'linear',
      className: 'h-[8px]',
    },
    {
      size: 'md',
      type: 'linear',
      className: 'h-[6px]',
    },
    {
      size: 'sm',
      type: 'linear',
      className: 'h-[4px]',
    },
  ],
  defaultVariants: {
    size: 'md',
    type: 'circular',
  },
});

export default function LoadingIndicator({
  size = 'md',
  type = 'circular',
  className,
}: LoadingIndicatorProps) {
  return (
    <>
      {type === 'circular' && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          className={cn(
            'animate-spin',
            loadingIndicatorVariants({ size, type }),
            className,
          )}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 3.42857C7.26613 3.42857 3.42857 7.26613 3.42857 12C3.42857 16.7339 7.26613 20.5714 12 20.5714C16.7339 20.5714 20.5714 16.7339 20.5714 12C20.5714 11.0532 21.3389 10.2857 22.2857 10.2857C23.2325 10.2857 24 11.0532 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C12.9468 0 13.7143 0.767512 13.7143 1.71429C13.7143 2.66106 12.9468 3.42857 12 3.42857Z"
            className={cn('fill-comp-loading-indicator-fill')}
          />
        </svg>
      )}
      {type === 'linear' && (
        <div
          className={cn(loadingIndicatorVariants({ size, type }), className)}
        >
          <div className="absolute h-full animate-[linear-progress_1.5s_ease-in-out_infinite,width-pulse_1.5s_ease-in-out_infinite] rounded-full bg-comp-loading-indicator-fill" />
        </div>
      )}
    </>
  );
}
